import React from 'react';
import PropTypes from 'prop-types';

import Img from '../../../Img';
import styles from '../collegeCoachActivity.scss';

const LOCK_ICON_COUNT = 12;
const LOCK_ICON_SRC = '/img/v2/icons/icon-feature-lock.svg';

const LockedTabContent = ({ summary, headline, testIdPrefix }) => {
    const bubbles = Array.from({ length: LOCK_ICON_COUNT }, (_, index) => index);

    return (
        <div className={styles.lockedPanel} data-testid={`${testIdPrefix}.locked`}>
            {summary && (
                <div
                    className={styles.lockedSummary}
                    data-testid={`${testIdPrefix}.locked.summary`}
                >
                    {summary}
                </div>
            )}
            {headline && (
                <div
                    className={styles.lockedHeadline}
                    data-testid={`${testIdPrefix}.locked.headline`}
                >
                    {headline}
                </div>
            )}
            <div className={styles.lockRow} data-testid={`${testIdPrefix}.locked.lock-row`}>
                {bubbles.map(index => (
                    <span
                        key={index}
                        className={styles.lockBubble}
                        data-testid={`${testIdPrefix}.locked.lock-bubble-${index}`}
                    >
                        <Img
                            src={LOCK_ICON_SRC}
                            alt=""
                            className={styles.lockBubbleIcon}
                        />
                    </span>
                ))}
            </div>
        </div>
    );
};

LockedTabContent.defaultProps = {
    summary: null,
    headline: null,
};

LockedTabContent.propTypes = {
    summary: PropTypes.string,
    headline: PropTypes.string,
    testIdPrefix: PropTypes.string.isRequired,
};

export default LockedTabContent;
